<template>
    <CreateModelLayout
        :indexRoute="$route('admin::languages.index')"
        :storeRoute="$route('admin::languages.store')"
        :modelNameSingular="__('admin::languages.language')"
        :modelNamePlural="__('admin::languages.languages')"
        :form="form"
    >

        <FormGroup :label="__('admin::labels.language')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.locale')" :error="errors.locale">
            <Input name="locale" type="text" :has-error="exists(errors.locale)" v-model="form.locale" :required="true" />
        </FormGroup>

    </CreateModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    locale: '',
                })
            }
        },
    }
</script>